import axios from "../../utils/axios";
import { BASE_API } from "../../config/app";
// 获取详细信息
export function edit(moduleKey, params, data, partKey, url) {
  return axios({
    url: BASE_API.rep(
      url === "false" || !url ? BASE_API.basis.edit.url : url,
      moduleKey,
      partKey
    ),
    method: "put",
    params: params,
    data: data
  });
}

export function add(moduleKey, params, data, partKey, url) {
  return axios({
    url: BASE_API.rep(
      url === "false" || !url ? BASE_API.basis.add.url : url,
      moduleKey,
      partKey
    ),
    method: "post",
    params: params,
    data: data
  });
}

export function save(moduleKey, params, data, partKey, url) {
  return axios({
    url: BASE_API.rep(
      url === "false" || !url ? BASE_API.basis.add.url : url,
      moduleKey,
      partKey
    ),
    method: "post",
    params: params,
    data: data
  });
}

export function batSave(moduleKey, params, data, partKey, url) {
  return axios({
    url: BASE_API.rep(
      url === "false" || !url ? BASE_API.basis.batSave.url : url,
      moduleKey,
      partKey
    ),
    method: "post",
    params: params,
    data: data
  });
}

export function modify(moduleKey, params, data, partKey, url) {
  return axios({
    url: BASE_API.rep(
      url === "false" || !url ? BASE_API.basis.modify.url : url,
      moduleKey,
      partKey
    ),
    method: "patch",
    params: params,
    data: data
  });
}
